import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "m12.8126 1.66837c-.5173-.23003-1.1079-.23003-1.6252 0-.3996.17765-.6591.49057-.8397.74554-.1776.2507-.36766.57912-.57674.94031l-8.26715 14.27968c-.20991.3625-.40066.6919-.530004.9715-.13145.2841-.274054.666-.228605 1.102.058811.5641.354349 1.0767.813069 1.4102.35449.2577.75649.3257 1.06825.3543.30675.0281.6874.0281 1.10629.0281h16.53429c.4189 0 .7996 0 1.1063-.0281.3118-.0286.7138-.0966 1.0683-.3543.4587-.3335.7542-.8461.813-1.4102.0455-.436-.0971-.8179-.2286-1.102-.1293-.2796-.32-.609-.5299-.9715l-8.2672-14.27971c-.2091-.36118-.3992-.6896-.5768-.94028-.1806-.25497-.4401-.56789-.8396-.74554zm.1874 7.33163c0-.55228-.4477-1-1-1s-1 .44772-1 1v4c0 .5523.4477 1 1 1s1-.4477 1-1zm-1 7c-.5523 0-1 .4477-1 1s.4477 1 1 1h.01c.5523 0 1-.4477 1-1s-.4477-1-1-1z",
      fill: "currentColor",
      "fill-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }